module.exports = __webpack_public_path__ + "images/FUSA_icons/093-tag.1568e47336b9c164ef051ab005ea4648.svg";